module.exports = __webpack_public_path__ + "static/media/wsu.4e5e8ff8.png";